import { useTranslation } from "react-i18next"
import { useParams, Link } from 'react-router-dom'
import Version from '../../version'

export function EmailSend() {
    const { t } = useTranslation()
    const { email } = useParams()

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-body text-center'>
                        <h4 className='fw-bold mb-3'>{t('forgot.emailsend1')}</h4>
                        <p className='text-muted mb-4'>{email}</p>
                        <p className='text-muted mb-4'>{t('forgot.emailsend2')}</p>
                        <Link to='/' className='btn btn-primary rounded-3'>{t('forgot.continue')}</Link>
                    </div>
                </div>
                <div className='text-center' style={{ marginTop: '20px' }}><Version /></div>
            </div>
        </div>
    )
}
